import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {
  AcceptedInvitationDto,
  AcceptInvitationViaIdentityDto,
  Brands,
  Clients,
  GeneralSettingDto,
  InvitationCheckDto,
  InvitationType,
  PasswordLoginDto,
  RefreshTokenV3Dto,
  RequestUserRegistrationDto,
  ResetPasswordDto,
  SettingType,
  TokenDto
} from "@server-models";
import {TeamErrorHandlerLoginService} from "@team/services/error-handler/team-error-handler-login.service";
import {
  TeamErrorHandlerResetPasswordService
} from "@team/services/error-handler/team-error-handler-reset-password.service";
import {TeamErrorHandlerGuestLoginTeamCodeService} from "@team/services/error-handler/team-error-handler-guest-login-team-code.service";
import {
  TeamErrorHandlerGuestLoginAcceptCodeService
} from "@team/services/error-handler/team-error-handler-guest-login-accept-code.service";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {
  SharedRegisterErrorHandlerService
} from "@shared/components/login/error-handler/shared-register-error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class TeamRegisterApiService extends CoreHttpClientApiBaseService {

  requestGuestPin(email: string): Observable<void> {
    const body: RequestUserRegistrationDto = {
      email,
      brand: Brands.Semco
    }
    return super.post<void>(`/identity/userRegistration/requestUserRegistration`, false, body);
  }

  requestGuestAsUser(pin: string, email: string, passwordBase64: string): Observable<void> {
    const body: any = {
      pinFromEmail: pin,
      passwordBase64: passwordBase64,
      email
    }
    const options = {
      errorHandler: new SharedRegisterErrorHandlerService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.post<void>(`/identity/userRegistration/registerUser`, false, body, options);
  }

  requestInvitationCodeAccept(code: string, lastName: string, pin: string): Observable<AcceptedInvitationDto> {
    const body: AcceptInvitationViaIdentityDto = {
      pin,
      lastName,
      type: InvitationType.Identify
    }
    const options = {
      errorHandler: new TeamErrorHandlerGuestLoginAcceptCodeService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.post<AcceptedInvitationDto>(`/tech/v2/invitationAcceptance/${ code }/accept`, true, body, options);
  }

  requestInvitationCodeCheck(code: string): Observable<InvitationCheckDto> {
    const options = {
      errorHandler: new TeamErrorHandlerGuestLoginTeamCodeService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.get<InvitationCheckDto>(`/tech/v2/invitationAcceptance/${ code }/check`, false, options);
  }

}
